import DebugConsole from './debug-console';

/**
 * Logs things to console using DebugConsole.
 * Decorates messages for each .info|.error call.
 * Use it as DebugConsole, currently only with
 * .info and .error
 */
class TaggedLogger {
  /**
   * Constructs
   * @param {string} name - Tag for logger
   * @param {string} style - Style for tag
   */
  constructor(name, style = 'color: black') {
    this.name = name;
    this.style = style;
    this.logger = new DebugConsole();
  }
  /**
   * Logs "log"
   * @param {...*} atts console.log attributes
   */
  info(...atts) {
    this.sendLog('log', [...atts]);
  }

  /**
   * Logs error
   * @param {...*} atts console.error attributes
   */
  error(...atts) {
    this.sendLog('error', [...atts]);
  }

  /**
   * Logs error
   * @param {...*} atts console.error attributes
   */
  warn(...atts) {
    this.sendLog('warn', [...atts]);
  }

  /**
   * Sends log
   * @param {string} level level
   * @param {Array} atts atts
   */
  sendLog(level, atts) {
    let attributes = atts;
    const tag = `%c[${this.name}] ${attributes[0]}`;
    attributes = attributes.slice(1);

    this.logger[level](tag, this.style, ...attributes);
  }
}

export default TaggedLogger;



// WEBPACK FOOTER //
// ./Library/1.0/common/debug/tagged-logger.js